import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function FinalCTA() {
  const contentAnim = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5683c2fa9ded66b57e9cacee4df000d4.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div
        ref={contentAnim.ref}
        className="relative max-w-3xl mx-auto px-6 lg:px-12 text-center"
        style={{
          opacity: contentAnim.isVisible ? 1 : 0,
          transform: contentAnim.isVisible ? 'translateY(0) scale(1)' : 'translateY(36px) scale(0.97)',
          transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        <h2 className="font-sora font-bold text-4xl lg:text-5xl text-white mb-5 leading-tight">
          Ready to upgrade your online presence?
        </h2>
        <p className="font-inter text-base text-white/60 mb-10 max-w-lg mx-auto">
          Let&apos;s build something that looks great and actually brings in customers.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-8">
          <Link
            to="/contact"
            className="bg-white text-charcoal px-9 py-4 rounded-xl font-inter font-semibold text-[15px] hover:bg-white/90 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            Book a Call
          </Link>
          <a
            href="mailto:lacruedigitalagency@gmail.com"
            className="border border-white/30 text-white px-9 py-4 rounded-xl font-inter font-medium text-[15px] hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Email Us
          </a>
        </div>

        <p className="font-inter text-sm text-white/40">
          <a
            href="mailto:lacruedigitalagency@gmail.com"
            className="hover:text-white/70 transition-colors cursor-pointer"
            rel="nofollow"
          >
            lacruedigitalagency@gmail.com
          </a>
        </p>
      </div>
    </section>
  );
}
